import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import LearningMapModal from '../Modal';
const CreateLearningMapButton: React.FC = () => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const [showLearningMap, setShowLearningMap] = useState<boolean>(false);

    const handleModalClose = () => {
        setShowLearningMap(false);
    };
    return (
        <div className="creation-button-container">
            <div className="creation-button" onClick={() => setShowLearningMap(!showLearningMap)}>
                <div className="icon-container">
                    <i className="material-icons-outlined align-middle chart-icon">{Constants.icons.SHOW_CHART}</i>
                </div>
                <div className="info-container">
                    <span className="title">{strings.SET_A_LEARNING_GOAL}</span>
                    <span className="description">{strings.LEARNING_GOAL_DESCRIPTION}</span>
                </div>
                <i className="material-icons-outlined align-middle arrow-icon">{Constants.icons.ARROW_RIGHT}</i>
            </div>
            <LearningMapModal handleModalClose={handleModalClose} showLearningMap={showLearningMap} />
        </div>
    );
};

export default CreateLearningMapButton;
